<template>
    <div class="overflow-x-hidden">
        <section
            class="text-center grid flex flex-wrap justify-content-center align-items-center  md:px-4 md:px-6 relative">
            <img src="@/assets/Images/flowers.png" alt="" class="decoration">
            <div class="col-10 md:pt-4 relative mt-4">
                <span class="badge mb-2">Teaching</span>
                <h2 class=" mb-2 LandingPage-Title">
                    Teaching Made Easy & Fun
                </h2>
                <p class="text-sm md:text-base text-gray-800 max-w-3xl mx-auto">
                    Teach with ease, enjoy every lesson, and reach students everywhere.
                </p>
            </div>
            <div class="grid surface-card col-11">
                <div v-for="(feature, index) in teachingFeatures" :key="index" class="col-12 md:col-4 md:px-4" >
                    <div class="feature-card p-5 pb-0 border-round-xl text-center h-full "  v-animateonscroll="{
                enterClass: 'animate-enter ' + getEnterClass(index)
            }">
                        <div class="feature-image shadow-2">
                            <img :src="feature.imageUrl" :alt="feature.title" class="w-full border-round-lg mb-0"
                                style=" object-fit: cover;" />
                            <p class="Paragraph-Medium mb-3 pb-3 mt-2 ">{{ feature.description }}</p>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import { usePublicUrl } from "@/utils/getPublicUrl"
import { ref, onMounted } from 'vue';

const teachingFeatures = ref([
    {
        image: "public/dashboard3.png",
        description: "Plan it, set it, teach it — your schedule, your way!",
        imageUrl: "" // Will be populated
    },
    {
        image: "public/dashboard2.png",
        description: "Track, and shine — all your lesson notes in one place.",
        imageUrl: ""
    },
    {
        image: "public/dashboard1.png",
        description: "Never miss a class — your smart reminder has got you covered",
        imageUrl: ""
    }
]);
const getEnterClass = (index) => {
    if (index === 0) return 'slide-in-top';
    if (index === 1) return 'slide-in-bottom';
    if (index === 2) return 'slide-in-top';
};

// const getLeaveClass = (index) => {
//     if (index === 0) return 'slide-out-top';
//     if (index === 1) return 'slide-out-bottom';
//     if (index === 2) return 'slide-out-top';
// };

onMounted(async () => {
    for (let feature of teachingFeatures.value) {
        try {
            const url = await usePublicUrl(feature.image);
            feature.imageUrl = url;
        } catch (error) {
            console.error('Error loading image:', feature.image, error);
        }
    }
});

</script>
<style scoped>
.decoration {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    height: 150px;
    object-fit: contain;
}

/* Responsive styles */
@media (max-width: 768px) {
    .decoration {
        height: 80px;
    }
}

@media (max-width: 480px) {
    .decoration {
        height: 80px;
    }
}
</style>